import { QueryClient } from 'react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            retryDelay: 1000,
        },
        mutations: {
            retry: 1,
        },
    },
});
